import { Observable, observe, Scope } from 'wdc-cube'
import { ResultadoDetalhadoBordero, ShowResultadoDetalhado } from '../bordero.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class ResultadoDetalhadoAnaliseScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() resultado = {} as ResultadoDetalhadoBordero

    onShowResults = Scope.ASYNC_ACTION_ONE<ShowResultadoDetalhado>()
    onClose = Scope.ASYNC_ACTION
}

export default ResultadoDetalhadoAnaliseScope
